import React from "react";
import "./styles.css";

const Projects = () => {
  return (
    <div className="projects-holder">
      <h3 className="projects-title"> - - - - - Projects - - - - -</h3>
      <div className="projects">
        <div className="project">
          <img
            src="https://uploads.codesandbox.io/uploads/user/e710feef-8b3e-426f-8d96-9a3bfec5832e/iBKW-primary1.png"
            alt="project"
          />
          <h2>Title</h2>
          <p>Project Desc</p>
          <a className="links" href="">
            <i class="fab fa-github ii" />
          </a>
          <a className="links" href="">
            <i class="fas fa-globe ii" />
          </a>
        </div>

        <div className="project">
          <img
            src="https://uploads.codesandbox.io/uploads/user/e710feef-8b3e-426f-8d96-9a3bfec5832e/iBKW-primary1.png"
            alt="project"
          />
          <h2>Title</h2>
          <p>Project Desc</p>
          <a className="links" href="">
            <i class="fab fa-github ii" />
          </a>
          <a className="links" href="">
            <i class="fas fa-globe ii" />
          </a>
        </div>

        <div className="project">
          <img
            src="https://uploads.codesandbox.io/uploads/user/e710feef-8b3e-426f-8d96-9a3bfec5832e/iBKW-primary1.png"
            alt="project"
          />
          <h2>Title</h2>
          <p>Project Desc</p>
          <a className="links" href="">
            <i class="fab fa-github ii" />
          </a>
          <a className="links" href="">
            <i class="fas fa-globe ii" />
          </a>
        </div>

        <div className="project">
          <img
            src="https://uploads.codesandbox.io/uploads/user/e710feef-8b3e-426f-8d96-9a3bfec5832e/iBKW-primary1.png"
            alt="project"
          />
          <h2>Title</h2>
          <p>Project Desc</p>
          <a className="links" href="">
            <i class="fab fa-github ii" />
          </a>
          <a className="links" href="">
            <i class="fas fa-globe ii" />
          </a>
        </div>

        <div className="project">
          <img
            src="https://uploads.codesandbox.io/uploads/user/e710feef-8b3e-426f-8d96-9a3bfec5832e/iBKW-primary1.png"
            alt="project"
          />
          <h2>Title</h2>
          <p>Project Desc</p>
          <a className="links" href="">
            <i class="fab fa-github ii" />
          </a>
          <a className="links" href="">
            <i class="fas fa-globe ii" />
          </a>
        </div>

        <div className="project p">
          <img
            src="https://uploads.codesandbox.io/uploads/user/e710feef-8b3e-426f-8d96-9a3bfec5832e/iBKW-primary1.png"
            alt="project"
          />
          <h2>Title</h2>
          <p>Project Desc</p>
          <a className="links" href="">
            <i class="fab fa-github ii" />
          </a>
          <a className="links" href="">
            <i class="fas fa-globe ii" />
          </a>
        </div>

        <div className="project p">
          <img
            src="https://uploads.codesandbox.io/uploads/user/e710feef-8b3e-426f-8d96-9a3bfec5832e/iBKW-primary1.png"
            alt="project"
          />
          <h2>Title</h2>
          <p>Project Desc</p>
          <a className="links" href="">
            <i class="fab fa-github ii" />
          </a>
          <a className="links" href="">
            <i class="fas fa-globe ii" />
          </a>
        </div>

        <div className="project p">
          <img
            src="https://uploads.codesandbox.io/uploads/user/e710feef-8b3e-426f-8d96-9a3bfec5832e/iBKW-primary1.png"
            alt="project"
          />
          <h2>Title</h2>
          <p>Project Desc</p>
          <a className="links" href="">
            <i class="fab fa-github ii" />
          </a>
          <a className="links" href="">
            <i class="fas fa-globe ii" />
          </a>
        </div>

        <div className="project p">
          <img
            src="https://uploads.codesandbox.io/uploads/user/e710feef-8b3e-426f-8d96-9a3bfec5832e/iBKW-primary1.png"
            alt="project"
          />
          <h2>Title</h2>
          <p>Project Desc</p>
          <a className="links" href="">
            <i class="fab fa-github ii" />
          </a>
          <a className="links" href="">
            <i class="fas fa-globe ii" />
          </a>
        </div>

        <div className="project p">
          <img
            src="https://uploads.codesandbox.io/uploads/user/e710feef-8b3e-426f-8d96-9a3bfec5832e/iBKW-primary1.png"
            alt="project"
          />
          <h2>Title</h2>
          <p>Project Desc</p>
          <a className="links" href="">
            <i class="fab fa-github ii" />
          </a>
          <a className="links" href="">
            <i class="fas fa-globe ii" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Projects;
